/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

import type { OrganizationTheme } from "../types";
import { forestCreamTheme } from "./themes/forest-cream";
import { navyBluesTheme } from "./themes/navy-blues";
import { neutralGoldTheme } from "./themes/neutral-gold";
import { richBrownsTheme } from "./themes/rich-browns";
import { sageGraysTheme } from "./themes/sage-grays";
import { warmEarthyTheme } from "./themes/warm-earthy";

export {
  forestCreamTheme,
  navyBluesTheme,
  neutralGoldTheme,
  richBrownsTheme,
  sageGraysTheme,
  warmEarthyTheme,
};

export const organizationThemes: Record<string, OrganizationTheme> = {
  "neutral-gold": neutralGoldTheme,
  "forest-cream": forestCreamTheme,
  "warm-earthy": warmEarthyTheme,
  "rich-browns": richBrownsTheme,
  "sage-grays": sageGraysTheme,
  "navy-blues": navyBluesTheme,
};

export const allThemes: OrganizationTheme[] = [
  neutralGoldTheme,
  forestCreamTheme,
  warmEarthyTheme,
  richBrownsTheme,
  sageGraysTheme,
  navyBluesTheme,
];
